import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class HandleWrapperOfficialPartner extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.init();
	}

	init() {
		let getCollapseOfficial = this.selector.querySelector('.raise-collapse-partner-logo')
		if (getCollapseOfficial){
			let getExtendWrapper = this.selector.querySelector('.js-expend-wrapper')
			let getListLayoutGrid:HTMLElement[] = Array.from(this.selector.querySelectorAll('.wp-block-jetpack-layout-grid'))
			if(window.matchMedia('(max-width: 767px)').matches){
				if(getListLayoutGrid.length > 1){
					let getLatestItem = getListLayoutGrid[0].querySelectorAll('.wp-block-jetpack-layout-grid-column')
					getExtendWrapper && (
						getListLayoutGrid.forEach((item,index)=>{
						if(index !== 0){
							let cloneNode = item.cloneNode(true)
							let elmAppend = getExtendWrapper.childNodes[0]
							elmAppend?.insertAdjacentHTML('afterbegin',cloneNode.outerHTML)
							if(getLatestItem.length === 4){
								let getLatest = getLatestItem[getLatestItem.length - 1].cloneNode(true)
								getLatest.classList.add('raise-container')
								getLatestItem[getLatestItem.length - 1].remove()
								elmAppend.insertAdjacentHTML('afterbegin',getLatest.outerHTML)
							}
							item.remove()
						}
					}))
				}
			}
		}
	}
}

export default HandleWrapperOfficialPartner;
